import React, { useState, useEffect, useRef, useMemo } from 'react';
import debounce from 'lodash.debounce';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import './NavbarHeader.css';

const NavbarHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [hoveredDropdown, setHoveredDropdown] = useState(null);
  const navbarRef = useRef(null); // Menggunakan ref untuk navbar
  const [isMouseInsideNavbar, setIsMouseInsideNavbar] = useState(false); // Menandakan apakah mouse berada dalam area navbar

  const handleScroll = () => {
    setScrolled(window.scrollY > 50);
  };

  const handleClickOutside = useMemo(() => 
    debounce((event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setHoveredDropdown(null);
      }
    }, 100), []
  );

  useEffect(() => {
    // Mencegah iframe hijacking (opsional)
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }

    // Tambahkan event listener
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);

  // Menangani ketika mouse masuk ke dalam dropdown
  const handleMouseEnter = (menu) => {
    setHoveredDropdown(menu); // Set hovered dropdown
  };

  // Menangani ketika mouse keluar dari dropdown
  const handleMouseLeave = () => {
    if (!isMouseInsideNavbar) {
      setHoveredDropdown(null); // Menutup dropdown jika mouse sudah tidak di navbar
    }
  };

  // Menangani ketika mouse masuk ke navbar
  const handleNavbarMouseEnter = () => {
    setIsMouseInsideNavbar(true); // Menandakan mouse berada di navbar
  };

  const handleNavbarMouseLeave = () => {
    setIsMouseInsideNavbar(false); // Menandakan mouse keluar dari navbar
  };

  // Menangani klik pada item submenu untuk menutup dropdown
  const handleItemClick = () => {
    setHoveredDropdown(null); // Menutup dropdown setelah item diklik
  };

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`navbar-header ${scrolled ? 'scrolled' : ''}`}
      ref={navbarRef} // Menambahkan ref untuk navbar
      onMouseEnter={handleNavbarMouseEnter}
      onMouseLeave={handleNavbarMouseLeave}
    >
      <Container>
        <Navbar.Brand href="/">
          <img src="/logo-upi-dan-yayasan.png" alt="UPI YPTK Logo" className="navbar-logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            {/* PROFILE Dropdown */}
            <NavDropdown
              title="PROFILE"
              id="profile-dropdown"
              show={hoveredDropdown === 'profile'}
              onMouseEnter={() => handleMouseEnter('profile')}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item href="/visi-misi" onClick={handleItemClick}>Visi dan Misi</NavDropdown.Item>
              <NavDropdown.Item href="/sejarah-upi-yptk" onClick={handleItemClick}>Sejarah</NavDropdown.Item>
              <NavDropdown.Item href="/pimpinan-kampus" onClick={handleItemClick}>Pimpinan Kampus</NavDropdown.Item>
              <NavDropdown.Item href="/struktur-organisasi-kampus" onClick={handleItemClick}>Struktur Organisasi</NavDropdown.Item>
              <NavDropdown.Item href="/mars-upi-yptk" onClick={handleItemClick}>Mars UPI YPTK</NavDropdown.Item>
              <NavDropdown.Item href="/fasilitas-upi-yptk" onClick={handleItemClick}>Fasilitas</NavDropdown.Item>
            </NavDropdown>

            {/* FAKULTAS Dropdown */}
            <NavDropdown
              title="FAKULTAS"
              id="fakultas-dropdown"
              show={hoveredDropdown === 'fakultas'}
              onMouseEnter={() => handleMouseEnter('fakultas')}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item href="https://filkom.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Ilmu Komputer</NavDropdown.Item>
              <NavDropdown.Item href="https://fdkv.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Desain Komunikasi Visual</NavDropdown.Item>
              <NavDropdown.Item href="https://fekon.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Ekonomi dan Bisnis</NavDropdown.Item>
              <NavDropdown.Item href="https://fpsi.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Psikologi</NavDropdown.Item>
              <NavDropdown.Item href="https://fkip.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Keguruan Ilmu Pendidikan</NavDropdown.Item>
              <NavDropdown.Item href="https://teknik.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Teknik</NavDropdown.Item>
            </NavDropdown>

            {/* PORTAL DIGITAL Dropdown */}
            <NavDropdown
              title="PORTAL DIGITAL"
              id="portal-dropdown"
              show={hoveredDropdown === 'portal'}
              onMouseEnter={() => handleMouseEnter('portal')}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item href="https://sisfo.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Sisfo UPI</NavDropdown.Item>
              <NavDropdown.Item href="http://elib.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>E-Library</NavDropdown.Item>
              <NavDropdown.Item href="http://elearning.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>E-Learning</NavDropdown.Item>
              <NavDropdown.Item href="http://lpmi.upiyptk.ac.id/home" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>LPMI</NavDropdown.Item>
              <h6 style={{ padding: '15px 30px 0px 30px' }}><strong>LPPM</strong></h6>
              <NavDropdown.Item href="https://upiyptk.ac.id/akreditasi/proposal/Proposal-Penelitian-Template.doc" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>
                Pedoman Proposal Penelitian
              </NavDropdown.Item>
              <NavDropdown.Item href="https://upiyptk.ac.id/akreditasi/proposal/Proposal-Pengabdian(Template).doc" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>
                Pedoman Proposal Pengabdian
              </NavDropdown.Item>
            </NavDropdown>

            {/* AKADEMIK Dropdown */}
            <NavDropdown
              title="AKADEMIK"
              id="akademik-dropdown"
              show={hoveredDropdown === 'akademik'}
              onMouseEnter={() => handleMouseEnter('akademik')}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item href="/akreditasi-kampus" onClick={handleItemClick}>Akreditasi Kampus</NavDropdown.Item>
              <NavDropdown.Item href="https://mbkm.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>MBKM</NavDropdown.Item>
              <NavDropdown.Item href="/pkm-upi-yptk" onClick={handleItemClick}>Program Kreatifitas Mahasiswa (PKM)</NavDropdown.Item>
              <NavDropdown.Item href="/beasiswa" onClick={handleItemClick}>Beasiswa</NavDropdown.Item>
              <NavDropdown.Item href="/tracer-studi-alumni" onClick={handleItemClick}>Tracer Studi</NavDropdown.Item>
            </NavDropdown>

            {/* JURNAL Dropdown */}
            <NavDropdown
              title="JURNAL"
              id="jurnal-dropdown"
              show={hoveredDropdown === 'jurnal'}
              onMouseEnter={() => handleMouseEnter('jurnal')}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item href="https://jbe-upiyptk.org/ojs/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Bisnis dan Ekonomi</NavDropdown.Item>
              <NavDropdown.Item href="https://jcivil-upiyptk.org/ojs/index.php/jcivil" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Civil Engineering</NavDropdown.Item>
              <NavDropdown.Item href="https://jcsitech-upiyptk.org/ojs/index.php/jcsitech" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Komputer dan Teknologi</NavDropdown.Item>
              <NavDropdown.Item href="https://jitekin-upiyptk.org/ojs/index.php/Teknologi" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>JITEKIN</NavDropdown.Item>
              <NavDropdown.Item href="https://jkomtekinfo.org/ojs/index.php/komtekinfo" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Komtek Info</NavDropdown.Item>
              <NavDropdown.Item href="https://jman-upiyptk.org/ojs/index.php/jman" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Majalah Ilmiah</NavDropdown.Item>
              <NavDropdown.Item href="https://jpsy165.org/ojs/index.php/jpsy165" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Psyche 165 Journal</NavDropdown.Item>
              <NavDropdown.Item href="https://judikatif-upiyptk.org/ojs/index.php/judikatif" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Judikatif</NavDropdown.Item>
              <NavDropdown.Item href="https://jlesson-upiyptk.org/ojs/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Lesson</NavDropdown.Item>
              <NavDropdown.Item href="https://jpti-upiyptk.org/ojs/index.php/jpti" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>PTI</NavDropdown.Item>
            </NavDropdown>

            {/* INFORMASI Dropdown */}
            <NavDropdown
              title="INFORMASI"
              id="informasi-dropdown"
              show={hoveredDropdown === 'informasi'}
              onMouseEnter={() => handleMouseEnter('informasi')}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item href="/newsroom" onClick={handleItemClick}>Newsroom</NavDropdown.Item>
              <NavDropdown.Item href="/kontak" onClick={handleItemClick}>Kontak</NavDropdown.Item>
            </NavDropdown>

            {/* PENDAFTARAN Dropdown */}
            <NavDropdown
              title="PENDAFTARAN"
              id="pendaftaran-dropdown"
              show={hoveredDropdown === 'pendaftaran'}
              onMouseEnter={() => handleMouseEnter('pendaftaran')}
              onMouseLeave={handleMouseLeave}
            >
              <NavDropdown.Item href="https://spmb.upiyptk.ac.id/" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>D3 dan S1</NavDropdown.Item>
              <NavDropdown.Item href="http://pascasarjana.upiyptk.ac.id/daftar/login" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Magister (S2)</NavDropdown.Item>
              <NavDropdown.Item href="https://psdti.upiyptk.ac.id/login" target="_blank" onClick={handleItemClick} rel = 'noopener noreferrer'>Doktor (S3)</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarHeader;
